var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-content" },
    [
      _c(
        "el-card",
        { staticClass: "mb5 searchContainer" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.params,
                "label-width": "auto",
                "label-position": "top",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10, type: "flex" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("customerManagements.title") },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t(
                                "GlobalSetObj.pleaseInputContent"
                              ),
                              clearable: "",
                            },
                            model: {
                              value: _vm.params.title,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.params,
                                  "title",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "params.title",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("compensationManagement.ClaimNumber"),
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder:
                                _vm.$t("collectionCenter.BatchQuery") +
                                "，" +
                                _vm.$t(
                                  "compensationManagement.Maximum500Orders"
                                ),
                              autosize: { minRows: 1, maxRows: 5 },
                              type: "textarea",
                            },
                            model: {
                              value: _vm.params.claimsNumberList,
                              callback: function ($$v) {
                                _vm.$set(_vm.params, "claimsNumberList", $$v)
                              },
                              expression: "params.claimsNumberList",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("compensationManagement.ClaimStatus"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.params.claimsStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.params, "claimsStatus", $$v)
                                },
                                expression: "params.claimsStatus",
                              },
                            },
                            _vm._l(_vm.STATUS, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.name, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("compensationManagement.ClaimType"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                multiple: "",
                                filterable: "",
                                placeholder: _vm.$t(
                                  "operationCenter.PleaseSelect"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.params.claimsTypes,
                                callback: function ($$v) {
                                  _vm.$set(_vm.params, "claimsTypes", $$v)
                                },
                                expression: "params.claimsTypes",
                              },
                            },
                            _vm._l(_vm.CLAIMS_TYPE, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.name, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("GlobalSetObj.CreatePeople") },
                        },
                        [
                          _c("UserSelectCmp", {
                            attrs: { "is-user-name": true },
                            model: {
                              value: _vm.params.createUser,
                              callback: function ($$v) {
                                _vm.$set(_vm.params, "createUser", $$v)
                              },
                              expression: "params.createUser",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "180px" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                  },
                                  model: {
                                    value: _vm.times,
                                    callback: function ($$v) {
                                      _vm.times = $$v
                                    },
                                    expression: "times",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "compensationManagement.ApplicationTime"
                                      ),
                                      value: "startedTime",
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("collectionCenter.EndTime"),
                                      value: "endedTime",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "datetimerange",
                              "start-placeholder": _vm.$t(
                                "GlobalSetObj.startDate"
                              ),
                              "end-placeholder": _vm.$t("GlobalSetObj.endDate"),
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            model: {
                              value: _vm.params.val2,
                              callback: function ($$v) {
                                _vm.$set(_vm.params, "val2", $$v)
                              },
                              expression: "params.val2",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.businessT"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                              },
                              on: { change: _vm.onClaimsNodeChange },
                              model: {
                                value: _vm.params.claimsNode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.params, "claimsNode", $$v)
                                },
                                expression: "params.claimsNode",
                              },
                            },
                            _vm._l(_vm.claimNode, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.name, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "180px" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                  },
                                  model: {
                                    value: _vm.orderType,
                                    callback: function ($$v) {
                                      _vm.orderType = $$v
                                    },
                                    expression: "orderType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("basicData.OrderNumber"),
                                      value: "orderNumber",
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "collectionCenter.customerNum"
                                      ),
                                      value: "customerNumber",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("el-input", {
                            staticClass: "input-with-select",
                            attrs: {
                              placeholder: _vm.$t(
                                "GlobalSetObj.pleaseInputContent"
                              ),
                              clearable: "",
                            },
                            model: {
                              value: _vm.params.val1,
                              callback: function ($$v) {
                                _vm.$set(_vm.params, "val1", $$v)
                              },
                              expression: "params.val1",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small", icon: "el-icon-search" },
              on: { click: _vm.onQuery },
            },
            [_vm._v(_vm._s(_vm.$t("operationCenter.Procurar")))]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", icon: "el-icon-refresh-left" },
              on: { click: _vm.onReset },
            },
            [_vm._v(" " + _vm._s(_vm.$t("operationCenter.reset")) + " ")]
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "div",
            { staticClass: "mb10 flex" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "but:compensationManagement:compensationList:add",
                      expression:
                        "'but:compensationManagement:compensationList:add'",
                      arg: "remove",
                    },
                  ],
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function () {
                      return _vm.onAddClaims()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("compensationManagement.ApplyForClaim")))]
              ),
              _c(
                "el-popover",
                { attrs: { placement: "bottom-start", trigger: "hover" } },
                [
                  _c(
                    "div",
                    { staticClass: "feet" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permit",
                              rawName: "v-permit:remove",
                              value:
                                "but:compensationManagement:compensationList:export",
                              expression:
                                "'but:compensationManagement:compensationList:export'",
                              arg: "remove",
                            },
                          ],
                          staticClass: "feet-btn",
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.onExport(1)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("CenterForSorting.export")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permit",
                              rawName: "v-permit:remove",
                              value:
                                "but:compensationManagement:compensationList:batch:export",
                              expression:
                                "'but:compensationManagement:compensationList:batch:export'",
                              arg: "remove",
                            },
                          ],
                          staticClass: "feet-btn",
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.onExport(2)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "compensationManagement.exportLinkedOrders"
                              )
                            )
                          ),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permit",
                              rawName: "v-permit:remove",
                              value:
                                "but:compensationManagement:batchExportSite:export",
                              expression:
                                "'but:compensationManagement:batchExportSite:export'",
                              arg: "remove",
                            },
                          ],
                          staticClass: "feet-btn",
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.onExport(3)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "compensationManagement.branchChangeDetailsExport"
                              )
                            )
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { slot: "reference", size: "small", type: "info" },
                      slot: "reference",
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("CenterForSorting.export")) + " "
                      ),
                      _c("i", {
                        staticClass: "el-icon-arrow-down el-icon--right",
                      }),
                    ]
                  ),
                ],
                1
              ),
              _c("dialogHook", {
                staticStyle: { "margin-left": "10px" },
                attrs: { "check-list": _vm.multipleSelection },
              }),
              _c("updataHook", { staticStyle: { "margin-left": "10px" } }),
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticClass: "table-height",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                height: _vm.tableHeightRow.height,
                border: "",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("operationCenter.ind"), width: "60px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              (_vm.pageNumber - 1) * _vm.pageSize +
                                scope.$index +
                                1
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("customerManagements.title"),
                  prop: "title",
                  width: "180",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("compensationManagement.ClaimNumber"),
                  prop: "claimsNumber",
                  width: "140",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-link",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.onOpen(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.claimsNumber))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("compensationManagement.ClaimStatus"),
                  prop: "claimsStatus",
                  width: "140",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          { attrs: { type: scope.row.tagType.type } },
                          [_vm._v(_vm._s(scope.row.tagType.name))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.businessT"),
                  prop: "claimsNodeStr",
                  width: "140",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("compensationManagement.ClaimType"),
                  prop: "claimsType",
                  width: "140",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              (_vm.CLAIMS_TYPE[scope.row.claimsType] &&
                                _vm.CLAIMS_TYPE[scope.row.claimsType].name) ||
                                ""
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("compensationManagement.ApplicationTime"),
                  prop: "applicationTime",
                  width: "160",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.EndTime"),
                  prop: "finishTime",
                  width: "160",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("compensationManagement.ApplyForClaimAmount"),
                  prop: "claimAmount",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("compensationManagement.ActualClaimAmount"),
                  prop: "actualClaimAmount",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "operationSource ",
                  label: _vm.$t("collectionCenter.DataSource"),
                  width: "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.operationSource === 1
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("receivablePayable.ManualAddition")
                                )
                              ),
                            ])
                          : _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("receivablePayable.SystemGenerated")
                                )
                              ),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.CreatePeople"),
                  prop: "createUserStr",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("Resource.Reviewer"),
                  prop: "reviewerStr",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("receivablePayable.ReviewTime"),
                  prop: "auditingTime",
                  width: "170",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("compensationManagement.Drawee"),
                  prop: "payerStr",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("receivablePayable.PaymentTime"),
                  prop: "paymentTime",
                  width: "170",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.pageNumber,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.pageSize,
                  total: _vm.total,
                  background: "",
                },
                on: {
                  "update:currentPage": function ($event) {
                    _vm.pageNumber = $event
                  },
                  "update:current-page": function ($event) {
                    _vm.pageNumber = $event
                  },
                  "update:pageSize": function ($event) {
                    _vm.pageSize = $event
                  },
                  "update:page-size": function ($event) {
                    _vm.pageSize = $event
                  },
                  "current-change": _vm.getCurrentTableData,
                  "size-change": _vm.getSizeTableData,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.$t("compensationManagement.ClaimApplication"),
            direction: "ltr",
            visible: _vm.createdVisible,
            "destroy-on-close": true,
            "append-to-body": true,
            "before-close": _vm.onAddClose,
            size: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.createdVisible = $event
            },
          },
        },
        [_c("CreatedForm", { on: { close: _vm.onAddClose } })],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.editTitle,
            direction: "ltr",
            visible: _vm.detailsVisible,
            "destroy-on-close": true,
            "append-to-body": true,
            "before-close": _vm.onEditClose,
            size: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailsVisible = $event
            },
          },
        },
        [
          _c("Details", {
            attrs: { id: _vm.id },
            on: { close: _vm.onEditClose },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }